import { RRugositeMaterial_Type } from '@batical/types/src'
import { fetchGenericSorted, fetchGeneric } from './GenericQ'
const Rugositeboussicaud20 = require('../json/Rugositeboussicaud20.json')
//RPerteChargeAccident
export function fetchRugositeMaterialSorted(): Array<{ value: string; label: string }> {
  return fetchGenericSorted(Rugositeboussicaud20)
}

export function fetchRugositeMaterial(uuid: string): RRugositeMaterial_Type {
  return fetchGeneric(Rugositeboussicaud20, uuid)
}
